export function LoadingScreen() {
  return (
    <div className="flex flex-col h-screen bg-gradient-to-b from-gray-50 to-gray-100">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 px-6 py-4 shadow-sm">
        <div className="max-w-4xl mx-auto flex items-center gap-4">
          <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl flex items-center justify-center shadow-md">
            <span className="text-white font-bold text-xl">H</span>
          </div>
          <div>
            <h1 className="text-xl font-bold text-gray-900">Hudl Coach</h1>
            <p className="text-sm text-gray-500">Your AI assistant coach</p>
          </div>
        </div>
      </header>

      {/* Centered spinner */}
      <div className="flex-1 flex items-center justify-center">
        <div className="w-10 h-10 border-4 border-gray-200 border-t-orange-500 rounded-full animate-spin" />
      </div>
    </div>
  );
}
